"use strict";

exports.__esModule = true;
exports.getUserActionDefinition = getUserActionDefinition;
exports.getUserActionDefinitions = getUserActionDefinitions;
var _OpenReport = require("./OpenReport");
var _AddPartCount = require("./AddPartCount");
var _ChangePartKind = require("./ChangePartKind");
var _ChangeOperator = require("./ChangeOperator");
var _CreateTicket = require("./CreateTicket");
var _CreateComment = require("./CreateComment");
var _ChangePartProcess = require("./ChangePartProcess");
var _ChangePartInstance = require("./ChangePartInstance");
var _action = require("./MapPartKind/action");
var _action2 = require("./MapPartInstance/action");
var _action3 = require("./MapOperator/action");
var _action4 = require("./MapPartProcess/action");
var _OpenDashboard = require("./OpenDashboard");
var _ManualMaintenance = require("./ManualMaintenance");
var userActionDefinitions;

/**
 * Get a list of user action definitions.
 */

function getUserActionDefinitions() {
  if (userActionDefinitions === undefined) {
    userActionDefinitions = [_CreateTicket.CreateTicketUserAction, _CreateComment.CreateCommentUserAction, _AddPartCount.AddPartCountUserAction, _ChangePartKind.ChangePartKindUserAction, _ChangePartProcess.ChangePartProcessUserAction, _ChangePartInstance.ChangePartInstanceUserAction, _ChangeOperator.ChangeOperatorUserAction, _OpenReport.OpenReportUserAction, _action.MapPartKindUserAction, _action2.MapPartInstanceUserAction, _action4.MapPartProcessUserAction, _action3.MapOperatorUserAction, _OpenDashboard.OpenDashboardUserAction, _ManualMaintenance.ManualMaintenanceUserAction];
  }
  return userActionDefinitions;
}

/**
 * Get the user action definition with the given name.
 */

function getUserActionDefinition(name, definitions) {
  if (definitions === void 0) {
    definitions = getUserActionDefinitions();
  }
  if (name === "OpenDeviceDetails") {
    // @fixme delete this branch when dashboards have been reset.

    return _OpenReport.OpenReportUserAction;
  }
  for (var i = 0; i < definitions.length; i++) {
    var def = definitions[i];
    if (def.name === name) {
      return def;
    }
  }
  throw new Error("Could not find a user action called " + name);
}